module.exports = __webpack_public_path__ + "static/media/ice1.91765300.webp";